export const UPGRADE_MODAL_TITLE = 'Subscribe for access to 7,000+ citation styles'

export const FREE_CTA_TEXT = `Try it for free today`

export const UCF_UPGRADE_MODAL_ID = '--ucf-upgrade-modal'

export const FOOTER_BANNER_TEXT = 'Already have an account?'
export const FOOTER_BANNER_CTA_TEXT = 'Sign in'
export const FREE_STYLE_TEXT = 'or keep citing in'
